const SETTINGS = {
  // id for portal container (we will dynamically load elements in this element)
  PORTAL_ID: 'ontruck-portal',
  // time between reloads
  RELOAD_TICKETS_LIST_INTERVAL_IN_SECONDS: 15,
  TICKETS_LIST_PAGE_SIZE: 50,
  TICKETS_TABLE_COLUMN_SIZES_IN_PX: {
    TICKET: '120px',
    LOCATIONS: '360px',
    SERVICE: '180px',
    LOAD: '150px',
    QUOTE: '110px',
    OWNER: '80px',
  },
  ALERTS_PAGE_SIZE: 20,
  ALERTS_NOTIFICATION_REFRESH_INTERVAL: 3000,
};

export default SETTINGS;
